export default __webpack_public_path__ + "static/media/sound.0beba7f2.webp";